import Vue from "vue";

export const changeUser = ({ dispatch }, user) => {
  Vue.http.post("api/v1/Users?userId=" + user.Id).then(function (response) {
    dispatch("USER_LOADED", user);
    Vue.http.get("api/v1/BPL").then(function (response) {
      dispatch("USER_BPL_LOADED", response.data);
    });
  });
};

export const searchImpersonation = ({ dispatch }, search) => {
  dispatch("SHOW_MODAL");
  Vue.http.get("api/v1/Users?searchString=" + search).then(function (response) {
    dispatch("USERS_LOADED", response.data);
  });
};

export const closeImpersonation = ({ dispatch }) => {
  dispatch("CLOSE_MODAL");
};



// WEBPACK FOOTER //
// ./src/views/impersonation/ImpersonationActions.js